import queryString from "query-string";
import Modal from "react-bootstrap/Modal";
import { useLocation } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import base_url from "../api/bootapi";

const SmspackbuyServiceForm = () => {
  const { search } = useLocation();
  const queryparam = queryString.parse(search);

  const [message, setmessage] = useState();
  const [error, seterror] = useState(false);
  const [loader, setloader] = useState(false);
  const [planlist, setplanlist] = useState([]);
  const [success, setsuccess] = useState(false);
  const [selectedplan, setselectedplan] = useState("");
  const [confirmmodal, setconfirmmodal] = useState(false);
  const [showsuccessmodal, setshowsuccessmodal] = useState(false);

  const messagesEndRef = useRef(null);

  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */
    checkcountry();
  }, []);

  const checkcountry = () => {
    setloader(true);
    axios
      .get("https://geolocation-db.com/json/")
      .then((res) => {
        if (res.data?.country_code) {
          getplanlist(res.data?.country_code);
        } else {
          getplanlist();
        }
      })
      .catch((err) => {
        getplanlist();
      });
  };

  const getplanlist = (flag = "") => {
    axios
      .get(`${base_url}/info/service_plan/revised?category=sms_pack`)
      .then((res) => {
        setloader(false);
        if (res.data.status) {
          let arr = [];
          res.data.plans.forEach((item) => {
            let planname = item["service_plan_name"].split("-");
            if (flag === "US" && planname.length < 2) {
              arr.push(item);
            } else if (flag !== "US" && planname.length > 1) {
              arr.push(item);
            }
          });
          setplanlist(arr);
        }
      });
  };
  const getclass = (val) => {
    let className = "planouterdiv";
    if (selectedplan === val) {
      className = "planouterdiv active";
    }
    return className;
  };
  const handleplan = (plan) => setselectedplan(plan);
  const handleconfirmmodal = () => {
    if (!selectedplan || selectedplan === "error") {
      setselectedplan("error");
      return;
    }
    setconfirmmodal(!confirmmodal);
  };
  const buysmspack = (e) => {
    if (!selectedplan || selectedplan === "error") {
      setselectedplan("error");
      return;
    }
    setconfirmmodal(!confirmmodal);
    let data = {
      customer_id: queryparam?.customer_id,
      sms_pack_id: selectedplan,
    };
    setloader(true);
    axios
      .post(`${base_url}/auth/buy/sms/pack`, data)
      .then((res) => {
        setloader(false);
        if (res.data.status) {
          setmessage(res.data.message);
          setsuccess(true);
          setshowsuccessmodal(true);
          seterror(false);
        } else {
          let error = res.data.message;
          if (res.data.error) error = error + " : " + res.data.error;
          setmessage(error);
          setsuccess(false);
          seterror(true);
          setloader(false);
          scrollToBottom();
        }
      })
      .catch((err) => {
        if (err.response) {
          let error = err.response.data?.message;
          if (err.response.data?.error) {
            error = error + " : " + err.response.data?.error;
          }
          setmessage(error);
        } else {
          setmessage("Something Went Wrong");
        }
        setsuccess(false);
        seterror(true);
        setloader(false);
        scrollToBottom();
      });
  };

  const handleCloseModal = () => {
    setshowsuccessmodal(false);
    setsuccess(true);
    scrollToBottom();
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div id="myForm">
      <div>
        <h4 className="cancellationobd_h4">Purchase SMS Pack</h4>
      </div>
      {loader ? (
        <img width={300} alt="loader" src="./loading.gif" />
      ) : (
        <>
          {queryparam?.customer_id && (
            <>
              <div className="form-group">
                <div className="row text-left form-group">
                  <div className="col-md-5 reactivationobd_font">Email :</div>
                  <div className="col-md-7 reactivationobd_font">
                    {queryparam?.email}
                  </div>
                </div>
                <div className="row text-left form-group">
                  <div className="col-md-5 reactivationobd_font">
                    Customer ID :
                  </div>
                  <div className="col-md-7 reactivationobd_font">
                    {queryparam?.customer_id}
                  </div>
                </div>
              </div>
              <div>
                <div className="row mx-0">
                  {planlist.map((item, index) => (
                    <div className="col-md-6" key={index}>
                      <div
                        className={getclass(item.service_plan_id)}
                        onClick={() => handleplan(item.service_plan_id)}
                      >
                        <span className="plancheckmark"></span>
                        <h4>
                          {item.service_plan_name &&
                            item.service_plan_name.split("-")?.[0]}
                        </h4>
                        <p className="planmodalpricing">
                          <span>Price - ${item.price}</span>
                        </p>
                        <hr />
                        <div className="planselectbtndiv">
                          <button
                            className="planselectbutton"
                            onClick={() => handleplan(item.service_plan_id)}
                          >
                            {selectedplan === item.service_plan_id
                              ? "Selected"
                              : "Select"}
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {selectedplan === "error" && (
                  <span className="errormessage">
                    <span>
                      <i
                        className="fa fa-times errorifont"
                        aria-hidden="true"
                      ></i>
                    </span>
                    Plan is Required
                  </span>
                )}
              </div>
              {error ? (
                <div>
                  <div className="alert alert-danger">
                    <strong>Error! </strong>
                    {message}
                  </div>
                </div>
              ) : null}
              <div ref={messagesEndRef} />
              {success ? (
                <div>
                  <div className="alert alert-success">
                    <strong>Success! </strong>
                    {message}
                  </div>
                </div>
              ) : (
                <div
                  className="activation"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div></div>
                  <button
                    className={"btn btn-primary"}
                    onClick={handleconfirmmodal}
                  >
                    Buy SMS Pack
                  </button>
                </div>
              )}

              <Modal
                size="md"
                show={showsuccessmodal}
                onHide={() => handleCloseModal()}
                backdrop="static"
              >
                <Modal.Header closeButton={() => handleCloseModal()}>
                  <Modal.Title style={{ color: "#3947e6" }}>
                    Success!!
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <h4 className="form-main" style={{ color: "#3947e6" }}>
                    {message}
                  </h4>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    onClick={() => handleCloseModal()}
                    type="button"
                    className="btn btn-primary"
                  >
                    Ok
                  </button>
                </Modal.Footer>
              </Modal>
              <Modal
                size="md"
                show={confirmmodal}
                onHide={() => handleconfirmmodal()}
                backdrop="static"
              >
                <Modal.Header closeButton={() => handleconfirmmodal()}>
                  <Modal.Title style={{ color: "#3947e6" }}>
                    Confirmation
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <h4 className="form-main" style={{ color: "#3947e6" }}>
                    Are you sure you want to buy pack?
                  </h4>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    onClick={() => buysmspack()}
                    type="button"
                    className="btn btn-primary"
                  >
                    Yes
                  </button>
                  <button
                    onClick={() => handleconfirmmodal()}
                    type="button"
                    className="btn btn-primary"
                  >
                    No
                  </button>
                </Modal.Footer>
              </Modal>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default SmspackbuyServiceForm;
